import {
  type FamilyRegistry,
  familyRegistryListSchema,
} from '../schema';

export const FAMILY_REGISTRIES = familyRegistryListSchema.parse([
  {
    id: 'btob_inquiry',
    label: 'BtoB Inquiry',
    description: '法人向けサービスの問い合わせ獲得に最適化した family。',
    version: 1,
    status: 'active',
    priority: 100,
    tags: ['b2b', 'inquiry'],
    objectiveMatches: ['inquiry', 'document_request'],
    industryMatches: ['b2b_service', 'general_other'],
    preferredAppealStyles: ['problem_solution', 'trust_relief', 'authority_expert'],
    avoidedAppealStyles: ['offer_push'],
    requiredSectionTypes: ['hero', 'problem', 'solution', 'services', 'proof', 'cta', 'form'],
    recommendedSectionTypes: ['features', 'comparison', 'review', 'faq', 'use_cases'],
    discouragedSectionTypes: ['access', 'offer'],
    defaultSkeletonIds: ['skeleton_btob_inquiry_default'],
    defaultThemeIds: ['theme_corporate_clean', 'theme_trust_neutral'],
    notes: ['比較検討しやすさと信頼性を両立する'],
  },
  {
    id: 'saas_ai_inquiry',
    label: 'SaaS / AI Inquiry',
    description: 'SaaS や AI プロダクトの問い合わせ獲得に向けた family。',
    version: 1,
    status: 'active',
    priority: 100,
    tags: ['saas', 'ai', 'inquiry'],
    objectiveMatches: ['inquiry', 'document_request'],
    industryMatches: ['saas_ai'],
    preferredAppealStyles: ['feature_understanding', 'problem_solution', 'trust_relief'],
    avoidedAppealStyles: ['offer_push'],
    requiredSectionTypes: ['hero', 'problem', 'solution', 'feature_list', 'proof', 'cta', 'form'],
    recommendedSectionTypes: ['features', 'comparison', 'use_cases', 'faq'],
    discouragedSectionTypes: ['access'],
    defaultSkeletonIds: ['skeleton_saas_ai_inquiry_default'],
    defaultThemeIds: ['theme_modern_trust', 'theme_corporate_clean'],
    notes: ['UI キャプチャや比較表と相性が良い'],
  },
  {
    id: 'regional_service_inquiry',
    label: 'Regional Service Inquiry',
    description: '地域サービスや相談型サービスの問い合わせ導線向け family。',
    version: 1,
    status: 'active',
    priority: 90,
    tags: ['regional', 'service'],
    objectiveMatches: ['inquiry', 'reservation'],
    industryMatches: ['regional_service', 'general_other'],
    preferredAppealStyles: ['trust_relief', 'problem_solution', 'story_empathy'],
    avoidedAppealStyles: ['authority_expert'],
    requiredSectionTypes: ['hero', 'services', 'reasons', 'proof', 'cta', 'form'],
    recommendedSectionTypes: ['review', 'faq', 'access', 'message'],
    discouragedSectionTypes: ['comparison'],
    defaultSkeletonIds: ['skeleton_regional_service_inquiry_default'],
    defaultThemeIds: ['theme_natural_warm', 'theme_trust_neutral'],
    notes: ['安心感と相談しやすさを優先する'],
  },
  {
    id: 'store_reservation',
    label: 'Store Reservation',
    description: '店舗予約や来店導線を主目的とする family。',
    version: 1,
    status: 'active',
    priority: 95,
    tags: ['store', 'reservation'],
    objectiveMatches: ['reservation'],
    industryMatches: ['regional_service', 'general_other'],
    preferredAppealStyles: ['benefit_future', 'offer_push', 'trust_relief'],
    avoidedAppealStyles: ['authority_expert'],
    requiredSectionTypes: ['hero', 'services', 'review', 'access', 'cta'],
    recommendedSectionTypes: ['pricing', 'faq', 'offer', 'proof'],
    discouragedSectionTypes: ['comparison', 'feature_list'],
    defaultSkeletonIds: ['skeleton_store_reservation_default'],
    defaultThemeIds: ['theme_bright_friendly', 'theme_natural_warm'],
    notes: ['モバイルで迷わず予約できることを重視する'],
  },
  {
    id: 'd2c_purchase',
    label: 'D2C Purchase',
    description: '商品の購入を主目的とする D2C family。',
    version: 1,
    status: 'active',
    priority: 95,
    tags: ['d2c', 'purchase'],
    objectiveMatches: ['purchase'],
    industryMatches: ['d2c_product'],
    preferredAppealStyles: ['benefit_future', 'offer_push', 'story_empathy'],
    avoidedAppealStyles: ['authority_expert'],
    requiredSectionTypes: ['hero', 'benefit', 'features', 'pricing', 'cta'],
    recommendedSectionTypes: ['review', 'offer', 'faq', 'proof'],
    discouragedSectionTypes: ['comparison'],
    defaultSkeletonIds: ['skeleton_d2c_purchase_default'],
    defaultThemeIds: ['theme_premium_minimal', 'theme_bright_friendly'],
    notes: ['価格と価値の納得感を短い導線で作る'],
  },
  {
    id: 'seminar_application',
    label: 'Seminar Application',
    description: 'セミナーやイベント申込向け family。',
    version: 1,
    status: 'active',
    priority: 92,
    tags: ['seminar', 'event'],
    objectiveMatches: ['application'],
    industryMatches: ['seminar_event', 'general_other'],
    preferredAppealStyles: ['authority_expert', 'benefit_future', 'trust_relief'],
    avoidedAppealStyles: ['people_culture'],
    requiredSectionTypes: ['hero', 'overview', 'speaker', 'cta', 'form'],
    recommendedSectionTypes: ['offer', 'proof', 'faq', 'target_audience'],
    discouragedSectionTypes: ['access'],
    defaultSkeletonIds: ['skeleton_seminar_application_default'],
    defaultThemeIds: ['theme_formal_trust', 'theme_modern_trust'],
    notes: ['登壇者と参加メリットの明確化が重要'],
  },
  {
    id: 'education_application',
    label: 'Education Application',
    description: 'スクールや講座申込向け family。',
    version: 1,
    status: 'active',
    priority: 92,
    tags: ['education', 'school'],
    objectiveMatches: ['application'],
    industryMatches: ['education_school'],
    preferredAppealStyles: ['trust_relief', 'benefit_future', 'authority_expert'],
    avoidedAppealStyles: ['offer_push'],
    requiredSectionTypes: ['hero', 'course_or_curriculum', 'instructor', 'proof', 'cta', 'form'],
    recommendedSectionTypes: ['faq', 'pricing', 'target_audience', 'review'],
    discouragedSectionTypes: ['access'],
    defaultSkeletonIds: ['skeleton_education_application_default'],
    defaultThemeIds: ['theme_formal_trust', 'theme_trust_neutral'],
    notes: ['不安解消と学習内容の可視化を重視する'],
  },
  {
    id: 'recruitment_entry',
    label: 'Recruitment Entry',
    description: '採用応募を獲得するための recruitment family。',
    version: 1,
    status: 'active',
    priority: 94,
    tags: ['recruitment', 'entry'],
    objectiveMatches: ['recruitment', 'application'],
    industryMatches: ['recruitment', 'general_other'],
    preferredAppealStyles: ['people_culture', 'story_empathy', 'trust_relief'],
    avoidedAppealStyles: ['offer_push'],
    requiredSectionTypes: ['hero', 'work_style', 'people', 'proof', 'cta', 'form'],
    recommendedSectionTypes: ['message', 'faq', 'review'],
    discouragedSectionTypes: ['pricing', 'access'],
    defaultSkeletonIds: ['skeleton_recruitment_entry_default'],
    defaultThemeIds: ['theme_trust_neutral', 'theme_natural_warm'],
    notes: ['文化・働き方・実際の人の見え方を揃える'],
  },
]);

export const familyRegistryMap = new Map(
  FAMILY_REGISTRIES.map((family) => [family.id, family] as const),
);

export function getFamilyRegistry(
  familyId: FamilyRegistry['id'],
): FamilyRegistry | undefined {
  return familyRegistryMap.get(familyId);
}
